<template>
  <nav class="primaryNav">
    <div class="container">
      <div class="primaryNavContainer">
        <div class="primaryNavGroup">
          <router-link class="navbar-brand" to="/">
            <img
                height="27"
                width="auto"
                alt="AirGateway logo"
                :src="require('@/assets/images/airgateway-logo-icon-text.png')"
            />
          </router-link>
        </div>
        <div class="primaryNavGroup appNav">
          <template v-if="isLogged()">
              <router-link class="nav-link" to="/member/dashboard">Dashboard</router-link>
              <router-link v-if="can('front.stats')" class="nav-link" to="/member/analytics">Analytics</router-link>
              <router-link v-if="can('front.application')" class="nav-link" to="/applications">Applications</router-link>
              <router-link v-if="can('front.airlines')" class="nav-link" to="/member/airlines">Airlines</router-link>
          </template>
        </div>
        <div class="primaryNavGroup">
          <template v-if="!isLogged()">
            <router-link v-if="isShowSignup" class="nav-link" to="/register">Register</router-link>
            <a class="nav-link" @click="login()">
              <img
                  height="24"
                  width="24"
                  :src="require('@/assets/images/icon-user.svg')"
                  alt=""
              />
              Login
            </a>
          </template>
          <b-navbar-nav class="menuUser" v-if="isLogged()">
            <div class="dropdown username-dropdown" ref="usernameDropdown">
              <a class="nav-link username-toggle dropdown-toggle" @click="toggleDropdown">
                <img
                    height="24"
                    width="24"
                    :src="require('@/assets/images/icon-user.svg')"
                    alt=""
                />
                {{ userName }}
              </a>
              <div class="dropdown-menu username-dropdown-menu" v-if="isDropdownOpen">
                <router-link v-if="can('front.agency.settings')"
                             to="/member/profile"
                             class="dropdown-item"
                             @click.native="closeDropdown">
                  Edit agency
                </router-link>
                <div class="dropdown nested-agencies-dropdown show"
                     v-if="agencies && agencies.length">
                  <a class="dropdown-item">My agencies</a>
                  <div class="dropdown-menu nested-agencies-dropdown-menu">
                    <a class="dropdown-item"
                       v-for="agency of agencies"
                       :key="agency.id"
                       :class="{ 'current-agency-item': agency.id === currentAgency.id }">
                      <div class="agency-container" @click="agency.id !== currentAgency.id ? switchAgency(agency) : null">
                        <img v-if="agency.image_url" class="agency-img" :src="agency.image_url" :alt="agency.name"
                             :class="{ 'current-agency': agency.id === currentAgency.id }">
                        <div v-else class="agency-img agency-img-container"
                             :class="{ 'current-agency': agency.id === currentAgency.id }">
                          {{ agency.name.substring(0, 1).toUpperCase() }}
                        </div>
                        <div class="d-flex flex-column">
                          <div style="font-weight: 600">
                            {{agency.name}}
                          </div>
                          <div v-if="agency.iata_number">
                            {{agency.iata_number}}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <a class="dropdown-item logout" @click="logout()">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" class="logout-icon">
                    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/>
                  </svg>
                  Log out
                </a>
              </div>
            </div>
          </b-navbar-nav>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from "@/services/axios";
import helpers from "@/mixins/helpers";


export default {
  name: "NavigationBar",
  data() {
    return {
      error: '',
      username: '',
      isConsumerOwner: false,
      agencies: [],
      currentAgency: {},
      isDropdownOpen: false,
    };
  },
  mixins: [helpers],
  mounted() {
    if (this.$localStorage.get("logged")) {
      axios.get('/agent/account/info').then((res) => {
        let result = res.data;
        this.username = result.data.email;
        this.plan = result.data.plan;
        this.isConsumerOwner = result.data.is_consumer_owner;

        axios.get('/agent/account/agencies').then((res) => {
          let result = res.data;
          if (result && result.Data.length) {
            const agencyID = this.$localStorage.get("agencyID");
            this.currentAgency = result.Data.find((agency) => agency.id === agencyID);
            this.agencies = result.Data.filter(agency => agency.role === 'manager').sort((a, b) =>
                a.id === this.currentAgency.id ? -1 : b.id === this.currentAgency.id ? 1 : 0
            );
          }
        })
      })

      setTimeout(() => {
        const notificationMessage = this.$localStorage.get('notificationMessage');
        if (notificationMessage) {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Success',
            text: notificationMessage,
          });

          this.$localStorage.remove('notificationMessage');
        }
      })
    }
  },
  methods: {
    isLogged() {
      return this.$localStorage.get("logged");
    },
    switchAgency(agency) {
      this.$localStorage.set('agency', agency.name);
      this.$localStorage.set('notificationMessage', 'Agency switched');
      this.closeDropdown();
      window.location.reload();
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        document.addEventListener('click', this.closeDropdownOnClickOutside);
      } else {
        document.removeEventListener('click', this.closeDropdownOnClickOutside);
      }
    },
    closeDropdownOnClickOutside(event) {
      if (this.$refs && this.$refs.usernameDropdown && !this.$refs.usernameDropdown.contains(event.target)) {
        this.isDropdownOpen = false;
        document.removeEventListener('click', this.closeDropdownOnClickOutside);
      }
    },
  },
  computed: {
    userName() {
      if (this.username) {
        return this.username;
      } else {
        return "User options";
      }
    },
    isShowSignup() {
      return process.env.VUE_APP_SHOW_SIGNUP === 'true'
    },
  }
};
//
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.primaryNav {
  background-color: #c00005;
  position: fixed;
  top: 0;
  z-index: 10;
  min-width: 320px;
  width: 100%;

  &Container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &Group {
    &.appNav {
      a.nav-link {
        text-transform: uppercase;
      }
    }
  }

  a {
    &:hover {
      color: white;
    }
  }

  .primaryNavGroup {

    a {
      &.nav-link {
        padding: 15px 10px;
        height: 54px;
        line-height: 24px;

        &:hover {
          background-color: #9a0004;
        }
      }

      &.menuUser {
        text-transform: lowercase;
      }
    }

    .username-dropdown {

      .dropdown-menu {
        padding: 0;
        z-index: 1001;
        overflow: auto;
        display: block;

        .dropdown-item {
          padding: 6px 16px;
          font-size: 16px;

          &.logout {
            display: flex;
            align-items: center;
            gap: 6px;

            .logout-icon path {
              fill: #a70000;
            }
            &:hover {
              .logout-icon path {
                fill: white;
              }
              background-color: #a70000;
            }
          }

          &:not(.logout) {

            &:hover {
              background-color: #ffc5c6;
              color: #292b2c;
            }
          }

          &.dropdown-toggle {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }

      &-menu {
        position: absolute !important;
        min-width: 100% !important;
      }

      .nested-agencies-dropdown {
        max-height: 65vh;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 5px;
        }

        &-menu {
          position: relative !important;
          margin: 4px 4px 0;
          padding: 0;
          border: none;
          border-radius: 0;
          background-color: #ffc5c6;

          .dropdown-item {
            margin-bottom: 4px;
            border-radius: 4px;
            background-color: white;

            &:hover {
              background-color: #f2f4f7 !important;
            }
          }
        }

        &.show {
          background-color: #ffc5c6 !important;
        }

        .current-agency-item {
          background-color: #f2f4f7 !important;
          cursor: default;
        }

        .agency-container {
          display: flex;
          align-items: center;
          gap: 8px;

          .agency-img {
            height: 36px;
            width: 36px;
            border-radius: 4px;

            &-container {
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 18px;
              color: #a70000;
              border: 1px solid #a70000;
            }

            &.current-agency {
              background: #a70000;
              color: white;
            }
          }
        }
      }
    }
  }
}
</style>
